var React = require('react');

function IconCloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.7072 14.1211L24 25.4141L25.4143 24L14.1213 12.707L25.4143 1.41406L24 0L12.7072 11.293L1.41431 0L0 1.41406L11.293 12.707L0 24L1.41431 25.4141L12.7072 14.1211Z"}));
}

IconCloseInline.defaultProps = {"viewBox":"0 0 26 26"};

module.exports = IconCloseInline;

IconCloseInline.default = IconCloseInline;
